module.exports = __webpack_public_path__ + "Server-Healthy.AzureServiceFabricCluster.6cdd674ccc8f3a008312f210fab4530e.hashedasset.svg";